export const PUSH_NEW_ORDER = 'PUSH_NEW_ORDER'
export const SET_ORDER_LIST = 'SET_ORDER_LIST'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const SET_FILTER_CONFIG = 'SET_FILTER_CONFIG'
